<template>
  <div>  
    <b-modal id="modal_calculos" size="md" title="Expediente - Económicos"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cerrar" ok-variant="outline-secondary">

        <div class="row">
            <div class="col-lg-12">
                <h4>Expediente <br><b>{{ ECC.exp }} </b></h4>                
                                                
                <div class="form-row">
                    <b-form-group label="Presupuestado" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.pre" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Adjudicado" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.adj" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Facturado" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.fac" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Ingresos" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.bas" v-uppercase required trim></b-form-input>
                    </b-form-group>
                </div>
                <div class="form-row">
                    <b-form-group label="Compras" class="col-6 col-sm-3 offset-sm-3">
                        <b-form-input disabled v-model="ECC.com" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Personal" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.per" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Gastos" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.gas" v-uppercase required trim></b-form-input>
                    </b-form-group>
                </div>
                <div class="form-row">
                    <b-form-group label="%Benef." class="col-6 col-sm-3 offset-sm-6">
                        <b-form-input disabled v-model="ECC.pbe" v-uppercase required trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Beneficio" class="col-6 col-sm-3">
                        <b-form-input disabled v-model="ECC.ben" v-uppercase required trim></b-form-input>
                    </b-form-group>
                </div>
            </div>
        </div>               
      
    </b-modal>
  </div>
</template>

<script>

//import login from '@/views/Login.vue'

export default {
  name: 'modal_calculos',
    props: {
        //exped: { type:Number, default: 0 }, 
        ECC: { type:Array, default: ()=> [] },
    },

    components: {
        //login,

    },

    data() {
        return {      
        }
    },

  created() {
    // if (this.logueado) {
    //   this.$router.push('/');    
    // }
  },

  computed: {
      E() {
          return {};
      }

  },

  methods: {
      close() {
          this.hideModal();    
          //this.$bvModal.hide(this.modal);
      },
  }
}
</script>
